import { i18n } from 'next-i18next/pages'
import { loadLocaleBundles } from 'shared/i18n/load-locale-bundles'
import { setLocaleCookie } from 'shared/utils/set-locale-cookie'

interface UpdateRuntimeLocaleOptions {
  i18n?: typeof i18n | null
  locale?: string
  persistCookie?: boolean
}

export const updateRuntimeLocale = async ({
  i18n,
  locale,
  persistCookie = true,
}: UpdateRuntimeLocaleOptions): Promise<boolean> => {
  if (!locale) return false

  if (!i18n || i18n.language === locale) {
    return false
  }

  await loadLocaleBundles(i18n, locale)
  await i18n.changeLanguage(locale)

  if (persistCookie) setLocaleCookie(locale)

  return true
}
